import styled from 'styled-components';

export const StyledProgressBar = styled.div<{ backgroundColor: string }>`
  .Polaris-ProgressBar__Indicator {
    background-color: ${(props) => props.backgroundColor};
  }
`;

export const FullHeightDiv = styled.div`
  height: 100%;

  .Polaris-ShadowBevel,
  .Polaris-Collapsible {
    height: 100%;
  }

  &:not(.not-full-inline) .Polaris-InlineStack {
    height: 100%;
  }

  &:not(.not-fullHeight-blockStack) .Polaris-BlockStack {
    height: 100%;
  }

  &:not(.not-fullHeight-box) .Polaris-Box {
    height: 100%;
  }
`;

export const PointerDiv = styled.div<{ isPointer?: boolean }>`
  cursor: ${({ isPointer = true }) => (isPointer ? 'pointer' : 'default')};
`;


export const BoldTextDiv = styled.div`
  .Polaris-Text--root,
  .Polaris-Link {
    font-weight: 550;
  }
`;
export const ButtonStyled = styled.div`
  .Polaris-Button {
    padding-left: 12px;
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }

  img {
    object-fit: cover;
  }
`;

export const CustomIcon = styled.div`
  height: 1rem;
  width: 1rem;
`;


export const FullWidthDiv = styled.div`
  width: 100%;

  > .Polaris-InlineStack {
    width: 100%;
  }

  .Polaris-BlockStack {
    width: 100%;
  }

  &.full-height {
    height: 100%;
  }
`

export const CustomColorGrowth = styled.div<{ color?: string }>`
  .Polaris-Text--root.Polaris-Text--bodyXs {
    color: ${({ color }) => color || 'inherit'};
  }
`;

export const CustomItalicText = styled.div`
  .Polaris-Text--root {
    font-style: italic;
  }
`

